import { render, staticRenderFns } from "./LandingPageMain.vue?vue&type=template&id=913511b4&"
import script from "./LandingPageMain.vue?vue&type=script&lang=js&"
export * from "./LandingPageMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports